import LoadingDots from "../UI/LoadingDots";
import { DDD } from "../../lib/ddd/ddd";
import classes from "./ProfileComponents.module.scss";
import Button from "../UI/Button";
import { useContext, useEffect, useState } from "react";
import { OrgIdContext } from "../../store/orgId_context";
import { useNavigate, useLocation } from 'react-router-dom';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const ClientModal2 =  ({orgId, orgKey, onClose, iframeUrl}) => {
    const [changingOrg, setChangingOrg] = useState(true);
    const { mainOrgId, mainOrgUsername } = useContext(OrgIdContext);
    const [error, setError] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const [prevLocation, setPrevLocation] = useState();

    useEffect(() => {
        if(!orgId)
            return;

        ddd.ChangeOrganization(orgId).then((res)=>{
            if(res?.result !== "ok")
                return setError("Unable to change organization ("+res?.error?.message+")");

            setChangingOrg(false);
        })
    }, [orgId])

    

    const onBackClick = () =>{
        ddd.ChangeOrganization(mainOrgId).then((res)=>{
            onClose();
        })
    }
    
    return (
        <>
          <div className={`${classes["client-container"]} d-flex`}>
            <div className="d-flex justify-content-between align-items-center">
            <Button className="px-5 py-2" onClick={onBackClick}>
                Back to my organization
            </Button>
            <p className={`m-0 py-2 ${classes["blue-text"]}`}>
                
            </p>
            </div>
            <div className="w-100 d-flex flex-column" style={{ flex: 1, padding:"0.5rem", marginTop:"1rem", border:"1px solid #005683"}}>
                {!changingOrg &&
                <iframe
                    src={iframeUrl}
                    title="edit-invoices-layout"
                    className="w-100"
                    style={{ flex: 1 }}
                ></iframe>
                }
                {changingOrg && !error && <>
                <div className="align-self-center">Please wait...</div>
                <div className="align-self-center"><LoadingDots/></div>
                </>}
                {error && <>
                    <div className="align-self-center">{error}</div>
                </>}
            </div>
          </div>
        </>)
}

export default ClientModal2;